import { Fragment } from 'react';
import { data } from './data';

const Portfolio = () => {
    return (
        <Fragment id="honestly" className="d-flex flex-column min-vh-100">
            <div
                key={"1"}
                id="welcome"
                className="d-flex flex-column justify-content-center align-items-center"
            >
                <img
                    className="img-fluid rounded"
                    src={data.icon}
                    alt={data.nick}
                    draggable="false"
                />
                <h2 className="pt-3 nocopy">{data.nama}</h2>
                <code className="text-dark nocopy">{data.jobs}</code>
            </div>

            <div key={"2"} id="main-1" className="h100">
                <h1 className="text-danger text-center nocopy">About Me</h1>
                <div className="about d-flex flex-row pt-5 pb-5">
                    {data.about.map((value, index) => (
                        <div className="about-child" key={`about-${index}`}>
                            <p className="col-md-12 text-center align-items-center nocopy">
                                {value}
                            </p>
                        </div>
                    ))}
                </div>
            </div>

            <div key={"3"} id="main-2" className="h100">
                <h1 className="text-success text-center nocopy">Social Media</h1>
                <div id="main-fw" className="d-flex flex-row justify-content-center">
                    {data.sosmed.map(({ img, tag, url }, index) => (
                        <div id="main-2-child" key={`sosmed-${index}`}>
                            <img
                                id="main-2-img"
                                draggable="false"
                                src={img}
                                alt={`sosmed-${tag}`}
                            />
                            <h4 id="main-2-h4" className="text-center nocopy">
                                <a
                                    draggable="false"
                                    href={url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {tag}
                                </a>
                            </h4>
                        </div>
                    ))}
                </div>
            </div>

            <div key={"4"} id="footer">
                <footer className="d-flex mt-auto text-center p-2 flex-column nocopy">
                    <span>
                        Made with &#10084; by{" "}
                        <a
                            draggable="false"
                            href="https://github.com/ipincamp"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {data.nick}
                        </a>
                    </span>
                    <span className="text-muted">
                        Copyright &copy; {new Date().getFullYear()} {data.path}
                    </span>
                </footer>
            </div>
        </Fragment>
    );
};

export default Portfolio;
